fragment TenantFragment on Tenant {
    id
    endpoint
    type
    subscription_plan
}